module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/223e926c7036a87ef1b5f5d6e07ac7eb.jpg";